/**
 * Utilidades para manejo estricto de fechas y horas en zona horaria Lima, Perú (America/Lima, UTC-5).
 */

export const TIMEZONE_PERU = 'America/Lima';

/**
 * Obtiene la fecha actual en Lima, Perú en formato YYYY-MM-DD
 * @returns {string} Ej: '2026-09-25'
 */
export const getFechaHoyLima = () => {
    try {
        return new Intl.DateTimeFormat('en-CA', {
            timeZone: TIMEZONE_PERU,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        }).format(new Date());
    } catch (e) {
        const d = new Date();
        return d.toISOString().slice(0, 10);
    }
};

/**
 * Obtiene la fecha de ayer en Lima, Perú en formato YYYY-MM-DD
 * @returns {string}
 */
export const getFechaAyerLima = () => {
    try {
        const ahora = new Date();
        ahora.setDate(ahora.getDate() - 1);
        return new Intl.DateTimeFormat('en-CA', {
            timeZone: TIMEZONE_PERU,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        }).format(ahora);
    } catch (e) {
        const d = new Date();
        d.setDate(d.getDate() - 1);
        return d.toISOString().slice(0, 10);
    }
};

/**
 * Obtiene la fecha de N días atrás en Lima, Perú en formato YYYY-MM-DD
 * @param {number} dias 
 * @returns {string}
 */
export const getFechaDiasAtrasLima = (dias = 7) => {
    try {
        const ahora = new Date();
        ahora.setDate(ahora.getDate() - dias);
        return new Intl.DateTimeFormat('en-CA', {
            timeZone: TIMEZONE_PERU,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        }).format(ahora);
    } catch (e) {
        const d = new Date();
        d.setDate(d.getDate() - dias);
        return d.toISOString().slice(0, 10);
    }
};

/**
 * Extrae la fecha YYYY-MM-DD de un registro según zona horaria America/Lima
 * @param {string|Date} fechaRaw 
 * @returns {string} YYYY-MM-DD
 */
export const extraerFechaLima = (fechaRaw) => {
    if (!fechaRaw) return '';
    // Si viene directamente de MySQL como "YYYY-MM-DD HH:MM:SS" (sin 'Z' ni offset)
    if (typeof fechaRaw === 'string' && /^\d{4}-\d{2}-\d{2}/.test(fechaRaw)) {
        if (!fechaRaw.includes('Z') && !fechaRaw.includes('+') && !fechaRaw.includes('T')) {
            return fechaRaw.slice(0, 10);
        }
    }
    try {
        const d = new Date(fechaRaw);
        if (isNaN(d.getTime())) return String(fechaRaw).slice(0, 10);
        return new Intl.DateTimeFormat('en-CA', {
            timeZone: TIMEZONE_PERU,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        }).format(d);
    } catch (e) {
        return String(fechaRaw).slice(0, 10);
    }
};

/**
 * Formatea la hora en formato HH:mm a en zona horaria Lima, Perú
 * @param {string|Date} fechaRaw 
 * @returns {string} Ej: '11:45 am'
 */
export const formatearHoraLima = (fechaRaw) => {
    if (!fechaRaw) return '';
    try {
        if (typeof fechaRaw === 'string' && fechaRaw.length >= 16 && !fechaRaw.includes('Z') && !fechaRaw.includes('T')) {
            return fechaRaw.slice(11, 16);
        }
        const d = new Date(fechaRaw);
        if (isNaN(d.getTime())) return String(fechaRaw).slice(11, 16);
        return new Intl.DateTimeFormat('es-PE', {
            timeZone: TIMEZONE_PERU,
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        }).format(d);
    } catch (e) {
        return String(fechaRaw).slice(11, 16);
    }
};

/**
 * Formatea una fecha YYYY-MM-DD a formato corto legible (ej: '25 Sep')
 * @param {string} fechaStr 
 * @returns {string}
 */
export const formatearFechaCortaLima = (fechaStr) => {
    if (!fechaStr) return '';
    try {
        const [year, month, day] = fechaStr.split('-').map(Number);
        const d = new Date(year, month - 1, day, 12, 0, 0);
        return new Intl.DateTimeFormat('es-PE', {
            timeZone: TIMEZONE_PERU,
            day: 'numeric',
            month: 'short'
        }).format(d);
    } catch (e) {
        return fechaStr;
    }
};
